/* eslint-disable */
import addDays from 'date-fns/add_days';
import isBefore from 'date-fns/is_before';
import subDays from 'date-fns/sub_days';
import convertWithTimezone from '../ConvertWithTimezone/DateTimeConvertWithTimezone.support';
import getTimezoneOffset from '../GetTimezoneOffset/DateTimeGetTimezoneOffset.support';
import now from '../Now/DateTimeNow.support';

/**
 * Converts the date into a new date in the timezone specified by the offset
 * @param {string} dateTimeISO8601 The date and time string in ISO8601 format
 * @param {string} cutOffTime The cutoff time in military time (ex. "15:00")
 * @param {number} daysFromToday The cutoff in days before or after today. (ex. -1 for 1 day before, 3 for 3 days after)
 * @returns {boolean} .
 */
const isBeforeCutOff = (dateTimeISO8601, cutOffTime, daysFromToday) => {
  const [dateOnly] = dateTimeISO8601.split(`T`);
  const offset = getTimezoneOffset(dateTimeISO8601);
  const orderCutOff = convertWithTimezone(`${dateOnly}T${cutOffTime}${offset}`, offset);
  const cutOff = Math.sign(daysFromToday) !== -1 ? subDays(orderCutOff, Math.abs(daysFromToday)) : addDays(orderCutOff, daysFromToday);
  const timeNow = now(offset);
  return isBefore(timeNow, cutOff);
};

export default isBeforeCutOff;
